export var FeedbackStatus;
(function (FeedbackStatus) {
    FeedbackStatus["DRAFT"] = "DRAFT";
    FeedbackStatus["SENT"] = "SENT";
    FeedbackStatus["ACTION_PLAN"] = "ACTION_PLAN";
    FeedbackStatus["ACTION_PLAN_APPROVE"] = "ACTION_PLAN_APPROVE";
    FeedbackStatus["FINISHED"] = "FINISHED";
})(FeedbackStatus || (FeedbackStatus = {}));
